<p class="text-sm font-medium leading-6 text-gray-700">Umsatz</p>
<p class="mt-1 text-3xl font-semibold tracking-tight text-gray-900" data-testid="event-revenue-total">
  {{ revenue().total | currency: 'EUR' }}
</p>

<!--
  The reconciliation, as a definition list: every row is a fact about the figure above it, so `<dl>` is what
  it is. Rows wrap on a phone by giving the label `min-w-0` and letting the amount keep its own column.
-->
<dl class="mt-2 space-y-1 text-sm">
  <div class="flex items-baseline justify-between gap-x-2">
    <dt class="min-w-0 text-gray-500">Artikel und Sonstiges</dt>
    <dd class="shrink-0 text-gray-700" data-testid="event-revenue-articles">
      {{ revenue().articles | currency: 'EUR' }}
    </dd>
  </div>

  @if (hasAdjustments()) {
    <div class="flex items-baseline justify-between gap-x-2">
      <dt class="min-w-0 text-gray-500">Rabatt</dt>
      <dd class="shrink-0 text-gray-700" data-testid="event-revenue-discount">
        {{ revenue().discount | currency: 'EUR' }}
      </dd>
    </div>
    <div class="flex items-baseline justify-between gap-x-2">
      <dt class="min-w-0 text-gray-500">Aufschlag</dt>
      <dd class="shrink-0 text-gray-700" data-testid="event-revenue-surcharge">
        {{ revenue().surcharge | currency: 'EUR' }}
      </dd>
    </div>
  }

  @if (hasOther()) {
    <div class="flex items-baseline justify-between gap-x-2">
      <dt class="min-w-0 text-gray-500">Pfand, Gutscheine und Anzahlungen</dt>
      <dd class="shrink-0 text-gray-700" data-testid="event-revenue-other">
        {{ revenue().other | currency: 'EUR' }}
      </dd>
    </div>
  }

  @if (hasReceivables()) {
    <div class="flex items-baseline justify-between gap-x-2 border-t border-gray-200 pt-1">
      <dt class="min-w-0 text-gray-500">davon bar oder mit Karte bezahlt</dt>
      <dd class="shrink-0 text-gray-700" data-testid="event-revenue-paid">
        {{ revenue().paid | currency: 'EUR' }}
      </dd>
    </div>
    <div class="flex items-baseline justify-between gap-x-2">
      <dt class="min-w-0 text-gray-500">davon Forderungen (Verkauf auf Rechnung)</dt>
      <dd class="shrink-0 text-gray-700" data-testid="event-revenue-receivables">
        {{ revenue().receivables | currency: 'EUR' }}
      </dd>
    </div>
  }
</dl>
